module.exports = __webpack_public_path__ + "img/stress.77d4c43b.jpg";